import React from 'react';
import imgResolver from '../utils/img-resolver';
import checkOverflow from "../utils/checkModalOverflow";

class CalculationModal extends React.Component {
    componentWillReceiveProps(nextProps) {
        if (this.props.isVisible !== nextProps.isVisible) {
            checkOverflow(nextProps.isVisible);
        }
    }

    render() {
        var classes = "modal-overlay calculation-modal-overlay";
        if (this.props.isVisible) classes += " active";

        return (
            <div onClick={this.toggleModal.bind(this)} className={classes}>
                <div onClick={this.modalClick.bind(this)} className="modal whitebox">
                    <header className="modal-header">
                        <h1>How is this calculated?</h1>
                        <button className="close" onClick={this.toggleModal.bind(this)}><span>&times;</span></button>
                    </header>

                    <div className="modal-content flag">
                        <div className="flag-left">
                            <img src={require('../styles/images/img-how.png')} />
                        </div>
                        <div className="body">
                            <p><strong>The average hourly rate</strong> is calculated based on all data that is inserted to the website for a certain position by other businessees. <strong>Potential people</strong> shows the number of workers who have set their minimal pay to what you have inserted as your hourly rate.</p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    modalClick(evt) {
        evt.stopPropagation();
    }

    toggleModal() {
        this.props.toggleModal();
    }
}

export default CalculationModal;



/** WEBPACK FOOTER **
 ** ./app/src/components/CalculationModal.js
 **/